import { Route, Routes } from "react-router";
import { NavItems } from "../../../common/helpers/navigation";
import AssessmentWelcome from "./assessmentWelcome";
import { AssessmentReview } from "./assessmentReview";
import { AssessmentChecks } from "./assessmentChecks";
import { ContactFacilitator } from "./contactFacilitator";

export const AssessmentLanding = (): JSX.Element => {
    return (
        <Routes>
            <Route path="*" element={<AssessmentWelcome />} />
            <Route path={NavItems.Assessments.AssessmentChecks.relativePath} element={<AssessmentChecks />} />
            <Route path={NavItems.Assessments.ContactFacilitator.relativePath} element={<ContactFacilitator />} />
            <Route path={NavItems.Assessments.AssessmentReview.relativePath} element={<AssessmentReview />} />
        </Routes>
    );
};
